import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import StorePage from './components/StorePage';
import { addFrontendProviders } from './utils/FrontendApplier';
import StoreItemUtils from './utils/StoreItemUtils';
app.initializers.add('xypp-point-bridge', () => {
  app.routes['pointSystem.shop'] = {
    path: '/rewards',
    component: StorePage
  };
  app.routes['pointSystem.shop.tab'] = {
    path: '/rewards/:tab',
    component: StorePage
  };
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    items.remove('pointSystem-shop');
  });
  addFrontendProviders('point-decoration', '装饰物', async options => {
    const items = await app.store.find('store-item');
    for (const item of items) if (item.provider() === 'point-decoration') options[item.attribute('provider_data')] = item.name();
  }, item => {
    const data = item.attribute('data') || {};
    if (data.image) return m("div", {
      className: 'xypp-preview xypp-preview--' + data.type
    }, m("img", {
      src: data.image,
      alt: item.name(),
      loading: "lazy"
    }));
    if (data.type === 'name_decoration') return m("div", {
      className: "xypp-preview"
    }, m("span", {
      className: 'ps-name-preview ps-name-' + (data.slug || data.preset || '')
    }, app.session.user?.username() || '云端旅人'));
    if (data.type === 'title_decoration') return m("div", {
      className: "xypp-preview"
    }, m("span", {
      style: data.custom_css || {
        color: data.color
      }
    }, data.title || item.name()));
    return m("div", {
      className: "xypp-preview"
    }, m("div", {
      className: 'ps-posthl-preview ps-posthl-' + (data.slug || '')
    }, item.name()));
  }, undefined, async () => {
    window.location.reload();
  });
  extend(StoreItemUtils.prototype, 'getUseButtonName', function (result, item) {
    if (item.provider() === 'point-decoration' && !result.disable) result.text = '装备';
  });
  extend(StoreItemUtils.prototype, 'getFilterProviderDict', function (_, options) {
    delete options['point-decoration'];
    options.avatar_decoration = '头像框';
    options.name_decoration = '昵称特效';
    options.title_decoration = '头衔';
    options.cover_decoration = '资料背景';
  });
}, -100);